import { Select } from "antd";
import styled from "styled-components";

export const Wrapper = styled(Select)`
  align-items: center;
  width: 100%;
  border-radius: 5px;

  .ant-select-selector {
    background: #fff !important;
    color: black !important;
    border: 1px solid black !important;
    border-radius: 3px !important;
    height: 39px;
    overflow: hidden; /* Add this line */

    .ant-select-selection-placeholder {
      color: black !important;
    }
  }

  .ant-select-arrow {
    color: black !important;
  }

  @media (max-width: 800px) {
    .ant-select-selector {
      padding: 0;
      border: none !important;
      outline: none !important;

      .ant-select-selection-placeholder {
        color: black !important;
      }
    }

    .ant-select-arrow {
      color: black !important;
    }
  }
`;
